import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios"
import { BASE_URL, headerConfig } from "../../config";

const initialState = {
	isLoading:true,
	Setting:null,
	error: null,
	message: null
}

const settingSlice = createSlice({
	name: 'settings',
	initialState,
	reducers: {
		clearError: (state, action) => {
			state.error = null;
		},
		clearMessage: (state, action) => {
			state.message = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(updateStaticValues.pending, (state, action) => {
			state.isLoading = true;
			state.error = null;
		})
		.addCase(updateStaticValues.rejected, (state, action) => {
			state.error = action.payload?.message;
			state.isLoading = false;
		})
		.addCase(updateStaticValues.fulfilled, (state,action) => {
			state.isLoading = false;
			state.error = null;
			state.message = action.payload?.message;
			state.Setting = action.payload?.settings
		}).addCase(updateEmailTemplates.pending, (state, action) => {
			state.isLoading = true;
			state.error = null;
		})
		.addCase(updateEmailTemplates.rejected, (state, action) => {
			state.error = action.payload?.message;
			state.isLoading = false;
		})
		.addCase(updateEmailTemplates.fulfilled, (state,action) => {
			state.isLoading = false;
			state.error = null;
			state.message = action.payload?.message;
			state.Setting = action.payload?.settings
		}).addCase(fetchFullSettings.pending, (state, action) => {
			state.isLoading = true;
			state.error = null;
		})
		.addCase(fetchFullSettings.rejected, (state, action) => {
			state.error = action.payload?.message;
			state.isLoading = false;
		})
		.addCase(fetchFullSettings.fulfilled, (state,action) => {
			state.isLoading = false;
			state.error = null;
			state.message = action.payload?.message;
			state.Setting = action.payload?.settings
		}).addCase(updateEmailSettings.pending, (state) => {
			state.isLoading = true; state.error = null;
		}).addCase(updateEmailSettings.rejected, (state,action) => {
			state.isLoading = false; state.error = action.payload?.message;
		}).addCase(updateEmailSettings.fulfilled, (state,action) => {
			state.isLoading = false; state.error = null; state.message = action.payload?.message; state.Setting = action.payload?.settings;
		})
		.addCase(updateBrandingSettings.pending,(state)=>{ state.isLoading = true; state.error=null; })
		.addCase(updateBrandingSettings.rejected,(state,action)=>{ state.isLoading=false; state.error=action.payload?.message; })
		.addCase(updateBrandingSettings.fulfilled,(state,action)=>{ state.isLoading=false; state.error=null; state.message=action.payload?.message; state.Setting=action.payload?.settings; })
		.addCase(updateSeoSettings.pending,(state)=>{ state.isLoading = true; state.error=null; })
		.addCase(updateSeoSettings.rejected,(state,action)=>{ state.isLoading=false; state.error=action.payload?.message; })
		.addCase(updateSeoSettings.fulfilled,(state,action)=>{ state.isLoading=false; state.error=null; state.message=action.payload?.message; state.Setting=action.payload?.settings; })
		.addCase(updateAuthSettings.pending,(state)=>{ state.isLoading=true; state.error=null; })
		.addCase(updateAuthSettings.rejected,(state,action)=>{ state.isLoading=false; state.error=action.payload?.message; })
		.addCase(updateAuthSettings.fulfilled,(state,action)=>{ state.isLoading=false; state.error=null; state.message=action.payload?.message; state.Setting=action.payload?.settings; })
		.addCase(updateMaintenanceSettings.pending,(state)=>{ state.isLoading=true; state.error=null; })
		.addCase(updateMaintenanceSettings.rejected,(state,action)=>{ state.isLoading=false; state.error=action.payload?.message; })
		.addCase(updateMaintenanceSettings.fulfilled,(state,action)=>{ state.isLoading=false; state.error=null; state.message=action.payload?.message; state.Setting=action.payload?.settings; });
	},
});

export const updateStaticValues = createAsyncThunk(
	'/setting/admin/static',
	async (data, { rejectWithValue }) => {
		try {
			const response = await axios.put(`${BASE_URL}/settings/update-static`, data,headerConfig());
			return response.data;
		} catch (error) {
			return rejectWithValue(error.response ? error.response.data : 'An error occurred');
		}
	}
);

export const updateEmailTemplates = createAsyncThunk(
	'/setting/admin/email',
	async (data, { rejectWithValue }) => {
		try {
			const response = await axios.put(`${BASE_URL}/settings/update-email`, data,headerConfig());
			return response.data;
		} catch (error) {
			return rejectWithValue(error.response ? error.response.data : 'An error occurred');
		}
	}
);

export const fetchFullSettings = createAsyncThunk(
	'/setting/admin/full',
	async (_, { rejectWithValue }) => {
		try {
			const response = await axios.get(`${BASE_URL}/settings`,headerConfig());
			return response.data;
		} catch (error) {
			return rejectWithValue(error.response ? error.response.data : 'An error occurred');
		}
	}
);

export const updateEmailSettings = createAsyncThunk(
	'/setting/admin/email-settings',
	async(data,{rejectWithValue})=>{
		try{
			const response = await axios.put(`${BASE_URL}/settings/update-email-settings`,data,headerConfig());
			return response.data;
		}catch(error){
			return rejectWithValue(error.response ? error.response.data : 'An error occurred');
		}
	}
)

export const updateBrandingSettings = createAsyncThunk(
	'/setting/admin/branding-settings',
	async(data,{rejectWithValue})=>{
		try{
			const response = await axios.put(`${BASE_URL}/settings/update-branding`,data,headerConfig());
			return response.data;
		}catch(error){
			return rejectWithValue(error.response ? error.response.data : 'An error occurred');
		}
	}
)

export const updateSeoSettings = createAsyncThunk(
	'/setting/admin/seo-settings',
	async(data,{rejectWithValue})=>{
		try{
			const response = await axios.put(`${BASE_URL}/settings/update-seo`,data,headerConfig());
			return response.data;
		}catch(error){
			return rejectWithValue(error.response ? error.response.data : 'An error occurred');
		}
	}
)

export const updateAuthSettings = createAsyncThunk(
	'/setting/admin/auth-settings',
	async(data,{rejectWithValue})=>{
		try{
			const response = await axios.put(`${BASE_URL}/settings/update-auth`,data,headerConfig());
			return response.data;
		}catch(error){
			return rejectWithValue(error.response ? error.response.data : 'An error occurred');
		}
	}
)

export const updateMaintenanceSettings = createAsyncThunk(
	'/setting/admin/maintenance',
	async (data, { rejectWithValue }) => {
		try {
			const response = await axios.put(`${BASE_URL}/settings/update-maintenance`, data, headerConfig());
			return response.data;
		} catch (error) {
			return rejectWithValue(error.response ? error.response.data : 'An error occurred');
		}
	}
);

export const {clearError,clearMessage} = settingSlice.actions
export default settingSlice.reducer